import Vue from 'vue';
import Dashboard from '../../views/IMSS/Dashboard.vue';

export default {
    sincronizarMovimientos(parametros) {
        return Vue.axios.post("seguridad-social/lotes/actualizacion", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getLotes(parametros) {
        return Vue.axios.get("seguridad-social/lotes/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    consultaConstancia(parametros) {
        return Vue.axios.post("seguridad-social/lotes/consulta-constancia", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    exportSeguridadSocial(parametros) {
        return Vue.axios.post("seguridad-social/lotes/export-dispmag", parametros, { responseType: 'blob' }).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },
    enviarIMSS(parametros) {
        return Vue.axios.post("seguridad-social/lotes", parametros).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },

    getDashboard(parametros) {
        return Vue.axios.get("seguridad-social/dashboard", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    catalogoIMSS(parametros) {
        return Vue.axios.get("catalogo/colecciones/imss", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getEmpleados(parametros) {
        return Vue.axios.get("seguridad-social/lotes/find-empleados", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}